var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "upload_file_component vertical" }, [
    _c(
      "div",
      { staticClass: "flex flex-direction-column" },
      [
        _vm.uploadedImage || _vm.uploadedKey
          ? _c(
              "button",
              {
                staticClass: "btn btn-info btn-xs",
                on: { click: _vm.uploadFileData },
              },
              [
                _c(
                  "v-popover",
                  {
                    attrs: {
                      popoverClass: "1111",
                      popoverInnerClass: "upload_file_component_popover",
                      update: (open) => {
                        _vm.console.log("111", open)
                      },
                      "close-directive": () => {
                        _vm.console.log("1112")
                      },
                      open: _vm.openTooltip,
                      trigger: "hover",
                      "auto-hide": true,
                    },
                  },
                  [
                    _c("div", [
                      _c("i", {
                        staticClass: "icon-fa icon-fa-eye color-white",
                      }),
                    ]),
                    _vm._v(" "),
                    _c("template", { slot: "popover" }, [
                      _c("div", { staticClass: "pre_image" }, [
                        _vm.uploadedImage
                          ? _c("img", { attrs: { src: _vm.uploadedImage.url } })
                          : _vm._e(),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.disableUpload
          ? _c(
              "div",
              {
                staticClass: "btn btn-outline-info btn-xs pointer relative",
                attrs: { type: "button" },
              },
              [
                _vm._v("\n      Выбрать\n      "),
                _c("input", {
                  ref: "uploadFilesInput",
                  staticClass: "input-file pointer hidded",
                  attrs: {
                    type: "file",
                    id: "uploadPhotos",
                    disabled: _vm.isSaving,
                    accept: "image/*",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.filesAdded(
                        $event.target.name,
                        $event.target.files
                      )
                    },
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.autoSave && !_vm.disableUpload
          ? _c("LoadingButton", {
              attrs: {
                title: '<i class="icon-fa icon-fa-save"></i>',
                loading: _vm.isSaving,
                color: "#4fc47f",
                onClick: () => _vm.saveFile(),
                className: "btn btn-outline-success btn-xs",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }